import React from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';
import * as swPush from "./swPush";

import { HashRouter } from 'react-router-dom';
import './assets/base.scss';
import Main from './OurPages/Main';
import configureStore from './config/configureStore';
import { Provider } from 'react-redux';

import { PersistGate } from "redux-persist/integration/react";


const {store, persistor} = configureStore();
const rootElement = document.getElementById('root');

const renderApp = Component => {
    ReactDOM.render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <HashRouter>
                    <Component />
                </HashRouter>
            </PersistGate>
        </Provider>,
        rootElement
    );
};

renderApp(Main);

if (module.hot) {
    module.hot.accept('./OurPages/Main', () => {
        const NextApp = require('./OurPages/Main').default;
        renderApp(NextApp);
    });
}
// serviceWorker.unregister();
// swPush.register();

